import {
  Box,
  IconButton,
  Text,
  SystemStyleObject,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@cdl/heartbeat-react';

interface Props {
  showButtons?: boolean;
  title: string;
  onChange: (direction: 1 | -1) => void;
}

const GRAPH_BUTTONS_STYLE: SystemStyleObject = {
  borderLeftRadius: 0,
  borderLeft: '1px solid',
  borderLeftColor: 'neutral.50',
  height: '50%',
  width: '1.7rem',
};

export const GenericPicker: React.FC<Props> = ({
  showButtons = true,
  title,
  onChange,
}) => {
  return (
    <Box
      height='2.5rem'
      display='flex'
      border='1px solid'
      borderColor='neutral.200'
      borderRadius='.25rem'
      bgColor='neutral.0'
    >
      <Box
        display='flex'
        flex={1}
        height='100%'
        data-testid='lead-picker-name'
        overflow='hidden'
        textOverflow='ellipsis'
        justifyContent='center'
        alignItems='center'
        whiteSpace='nowrap'
        margin='auto'
      >
        <Text>{title}</Text>
      </Box>
      {showButtons && (
        <Box display='flex' flexDirection='column'>
          <IconButton
            aria-label='next'
            variant='tertiary'
            data-testid='lead-picker-next'
            borderBottom='1px solid'
            borderColor='neutral.50'
            borderBottomRightRadius='0'
            sx={{ ...GRAPH_BUTTONS_STYLE }}
            _focus={{ boxShadow: 'none' }}
            _focusVisible={{ boxShadow: 'outline' }}
            onClick={() => onChange(1)}
          >
            <ChevronUpIcon />
          </IconButton>
          <IconButton
            aria-label='previous'
            variant='tertiary'
            data-testid='lead-picker-previous'
            borderTopRightRadius='0'
            sx={{ ...GRAPH_BUTTONS_STYLE }}
            _focus={{ boxShadow: 'none' }}
            _focusVisible={{ boxShadow: 'outline' }}
            onClick={() => onChange(-1)}
          >
            <ChevronDownIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
